export const customInputDesignProperties = {
  '&.MuiInputBase-root': { borderRadius: '4px' },
  '& .MuiInputBase-input': { ':focus': { borderRadius: '3px' } },
  '&.MuiInputBase-root:hover:before': {
    borderBottom: 'none !important',
  },
  '&.MuiFilledInput-root::before': {
    borderBottom: 'none',
  },
};
